import { COLORS } from 'constants/colors'
import { device } from 'constants/responsive'
import styled from 'styled-components'

export const Container = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-template-rows: repeat(2, 1fr);
  grid-column-gap: 14px;
  grid-row-gap: 14px;

  @media ${device.tablet} {
    display: flex;
    flex-direction: column;
    gap: 14px;
  }
`

export const Item = styled.div`
  display: flex;
  flex-direction: column;
  gap: 14px;
  max-width: 274px;
  padding: 24px;

  border-radius: 12px;
  border: 1px solid #d9ecf6;
  background: #f4fbff;

  @media ${device.tablet} {
    max-width: 100%;
  }
`

export const ItemTitle = styled.p`
  font-size: 20px;
  line-height: 1.2;
  color: ${COLORS.text.default};
`

export const ItemSubtitle = styled.p`
  font-size: 16px;
  line-height: 1.2;
  color: #677fa9;
`
